import { createStyles, makeStyles } from '@material-ui/core'

export const useHeaderPopoverStyles = makeStyles(
  (theme) =>
    createStyles({
      btn: {
        alignItems: 'center',
        cursor: 'pointer',

        '& .arrow': {
          marginLeft: 15,
          color: theme.palette.grey[300],
          transition: 'transform 0.2s linear'
        },

        '&.active': {
          '& .arrow': {
            transform: 'rotate(180deg)'
          }
        }
      },

      container: {
        minWidth: 250,
        paddingTop: 10,
        paddingBottom: 10,
        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.08)',
        borderRadius: '6px',

        '& > *': {
          padding: '5px 15px',

          '& > *': {
            width: '100%',
            textAlign: 'right'
          },

          '&:hover': {
            backgroundColor: theme.palette.grey[200],

            '& > *': {
              textDecoration: 'none',
              color: theme.palette.text.secondary,
              cursor: 'pointer'
            }
          }
        }
      }
    }),
  {
    name: 'HeaderPopover'
  }
)
